import {
	CreateIdentityVerificationSessionPayload,
	CreateVerificationSessionResponse,
	createIdentityVerificationSession,
} from "@/api/identity-verification";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

// Type for the mutation variables, excluding global_on_id and redirect_url
export type CreateIdentityVerificationSessionVariables = Omit<
	CreateIdentityVerificationSessionPayload,
	"global_on_id" | "redirect_url"
>;

export default function useCreateIdentityVerificationSession(
	options?: MutationOptionsWithoutFn<
		CreateVerificationSessionResponse,
		CreateIdentityVerificationSessionVariables
	>,
) {
	const REDIRECT_URL = `${window.location.origin}/main/validate-identity#validate_verification`;

	return useMutation({
		mutationFn: async (variables: CreateIdentityVerificationSessionVariables) =>
			await createIdentityVerificationSession({
				...variables,
				redirect_url: REDIRECT_URL,
			}),
		...options,
	});
}
